import { Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/button.gjs';
import styles from './promotional.module.scss';

const METADATA = Metadata.define({
  description: `
    Promotional button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Promotional Button',
  resources: {
    figma:
      'https://www.figma.com/design/g4zf0Vkj39VcCyleokv2rl/%E2%9D%96-Air-web-components?node-id=29957-4154&m=dev',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/p/56566c-button',
  },
});

export default class SpdsActionButtonPromotional extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-promotional';
  variantStyles = styles;
}

export const ACTION_BUTTON_PROMOTIONAL_METADATA = SpdsActionButtonPromotional.metadata;
